export type FileType = 'pdf' | 'docx' | 'png' | 'jpg' | 'default';

export const getFileExtension = (fileName: string): string =>
  fileName.split('.').pop()?.toLowerCase() ?? '';

export const getFileType = (fileName: string): FileType => {
  const extension = getFileExtension(fileName);
  switch (extension) {
    case 'pdf':
      return 'pdf';
    case 'doc':
    case 'docx':
      return 'docx';
    case 'png':
      return 'png';
    case 'jpg':
    case 'jpeg':
      return 'jpg';
    default:
      return 'default';
  }
};

export const getFileNameWithoutExtension = (fileName: string): string => {
  const lastDotIndex = fileName.lastIndexOf('.');

  return lastDotIndex > 0 ? fileName.slice(0, lastDotIndex) : fileName;
};

export const hasPdfExtension = (fileName: string): boolean =>
  getFileExtension(fileName) === 'pdf';

export const isPreviewableInBrowser = (fileName: string): boolean => {
  const extension = getFileExtension(fileName);
  return ['pdf', 'png', 'jpg', 'jpeg', 'gif', 'webp'].includes(extension);
};

export const createPdfObjectUrl = (data: Blob): string =>
  URL.createObjectURL(new Blob([data], { type: 'application/pdf' }));

const REVOKE_DELAY_MS = 1000;

export const revokeObjectUrlLater = (url: string) =>
  setTimeout(() => URL.revokeObjectURL(url), REVOKE_DELAY_MS);

export const triggerDownload = (url: string, filename: string) => {
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
};

export const formatFileSize = (bytes: number): string => {
  if (bytes < 1024) {
    return `${bytes} B`;
  }
  if (bytes < 1024 * 1024) {
    return `${Math.round(bytes / 1024)} kB`;
  }
  return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
};
